import React, { useState, useEffect } from "react";
import AOS from "aos";

import "aos/dist/aos.css";
import "./style.css";

const Services = () => {
  const [lang, setLang] = useState("En");

  useEffect(() => {
    if (localStorage.getItem("language") === "En") {
      setLang("En");
    } else if (localStorage.getItem("language") === "Fr") {
      setLang("Fr");
    }
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <div>
      <div class="bg-img">
        <div class="container">
          <div class="cover-title">
            {lang === "Fr" ? (
              <h1>Produits & Services</h1>
            ) : (
              <h1>Products & Services</h1>
            )}
          </div>
        </div>
      </div>
      <div class="section-services">
        <div class="container ">
          <div class="row top-content">
            <div class="col-md-5">
              {lang === "Fr" ? (
                <h1 class="products-title">Produits & Services</h1>
              ) : (
                <h1 class="products-title">Products & Services</h1>
              )}

              {lang === "Fr" ? (
                <p>
                  En tant que nouvelle société, Gold Bar International est
                  heureuse d’offrir un menu très simple et direct de produits et
                  de services liés à l’acquisition de produits aurifères et à la
                  logistique nécessaire à l’exécution physique d’une transaction
                  réussie.
                </p>
              ) : (
                <p>
                  As a new company, Gold Bar International is pleased to offer a
                  very simple, straight-forward menu of products and services
                  related to the acquisition of gold product, and the logistics
                  required to physically execute a successful transaction.
                </p>
              )}

              <div className="btns">
                {lang === "Fr" ? (
                  <a class="btn  ">Or</a>
                ) : (
                  <a class="btn  ">Gold</a>
                )}

                <span class="space"></span>
                <a class="btn  ">Production</a>
                <span class="space"></span>
                {lang === "Fr" ? (
                  <a class="btn   btn-border hidden-xs">Sécurité</a>
                ) : (
                  <a class="btn   btn-border hidden-xs">Security</a>
                )}
              </div>
            </div>
            <div class="col-md-7" data-anima="fade-right" data-time="1100">
              <img
                className="cover"
                src={require("../../Assets/ser-img.png")}
                alt=""
                style={{ transform: "translateX(100px)" }}
              />
            </div>
          </div>
        </div>
      </div>
      <div class="section-bg-color">
        <div class="container content">
          <div class="row">
            <div
              class="col-md-3"
              data-aos="fade-up"
              data-aos-duration="1500"
              data-aos-anchor-placement="top-bottom"
            >
              <div className="products-card">
                <a class="img-box lightbox img-scale-up">
                  <span>
                    <img src={require("../../Assets/services-1.jpg")} alt="" />
                  </span>
                </a>
                {lang === "Fr" ? (
                  <div class=" ">
                    <h3>Produit en Or</h3>
                    <p>
                      Barres Dore: Jusqu’à 10Kg. <br />
                      Barres bouillon : Environ 400 onces troy/27 livres/12,4
                      kg.
                    </p>
                  </div>
                ) : (
                  <div class=" ">
                    <h3>Gold Product</h3>
                    <p>
                      Dore Bars: Up to 10Kg. <br />
                      Bouillon Bars: Approximately 400 troy ounces/27
                      pounds/12.4Kg.
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div
              class="col-md-3"
              data-aos="fade-up"
              data-aos-duration="2000"
              data-aos-anchor-placement="top-bottom"
            >
              <div className="products-card">
                <a class="img-box lightbox img-scale-up">
                  <span>
                    <img
                      src={require("../../Assets/services-2r.jpg")}
                      width="261px"
                      height="164px"
                    />
                  </span>
                </a>
                {lang === "Fr" ? (
                  <div class=" ">
                    <h3>Quantités d'or</h3>
                    <p>
                      Commandes ponctuelles : 25 kg à 500 kg. Ordres de
                      fabrication pour des durées de 12 mois ou plus : 100 kg à
                      1 000 kg par mois. Veuillez nous contacter si vous avez
                      besoin d’options supplémentaires ou si vous avez des
                      exigences uniques.
                    </p>
                  </div>
                ) : (
                  <div class=" ">
                    <h3>Gold Quantities</h3>
                    <p>
                      One-Time Spot Orders: 25Kg to 500Kg. Production Orders for
                      Terms of 12 Months or Longer: 100Kg to 1,000Kg per Month.
                      Please contact us should you require additional options or
                      have unique requirements.
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div
              class="col-md-3"
              data-aos="fade-up"
              data-aos-duration="2500"
              data-aos-anchor-placement="top-bottom"
            >
              <div className="products-card">
                <a class="img-box lightbox img-scale-up">
                  <span>
                    <img
                      src={require("../../Assets/services-4.jpg")}
                      alt=""
                      width="261px"
                      height="164px"
                    />
                  </span>
                </a>
                {lang === "Fr" ? (
                  <div class=" ">
                    <h3>Prix de l'or</h3>
                    <p>
                      Les prix sont indexés sur le Bourse des métaux de Londres
                      (London Metal Exchange (LME)). <br />
                      Les remises sont sujettes à des fluctuations quotidiennes;
                      s’il vous plaît appelez pour des devis en temps opportun.
                    </p>
                  </div>
                ) : (
                  <div class=" ">
                    <h3>Gold Pricing</h3>
                    <p>
                      Prices are indexed to the London Metal Exchange (LME).
                      <br /> Discounts are subject to daily fluctuations; please
                      call for timely quotes.
                    </p>
                  </div>
                )}
              </div>
            </div>
            <div
              class="col-md-3"
              data-aos="fade-up"
              data-aos-duration="3000"
              data-aos-anchor-placement="top-bottom"
            >
              <div className="products-card">
                <a class="img-box lightbox img-scale-up">
                  <span>
                    <img
                      src={require("../../Assets/logistic.png")}
                      alt=""
                      width="261px"
                      height="164px"
                      style={{ background: " #fff" }}
                    />
                  </span>
                </a>
                {lang === "Fr" ? (
                  <div class=" ">
                    <h3>Livraison de produits/logistique</h3>
                    <p>
                      Quantité , Distance , Mode de transport. Exigences en
                      matière de sécurité et de main-d’œuvre. Des devis
                      logistiques personnalisés seront fournis avec chaque
                      transaction.
                    </p>
                  </div>
                ) : (
                  <div class=" ">
                    <h3>Product Delivery/Logistics</h3>
                    <p>
                      Quantity , Distance , Form of transportation.
                      Security/manpower requirements. <br />
                      Custom logistical quotes will be provided with every
                      transaction.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
